module.exports = __webpack_public_path__ + "static/img/13.6deae07.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/sp/13.png
// module id = azla
// module chunks = 0